import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AuthGate } from '@/auth/AuthGate';
import { TopBar } from '@/components/TopBar';
import { DashboardPage } from '@/pages/DashboardPage';
import { DesignPage } from '@/pages/DesignPage';
import { ManualPage } from '@/pages/ManualPage';
import { PanelBoardPage } from '@/pages/PanelBoardPage';
import { ProjectPage } from '@/pages/ProjectPage';

export function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-page text-ink">
        <TopBar />
        <main className="max-w-[1440px] mx-auto px-6 py-6">
          <Routes>
            <Route index element={<Navigate to="/manual" replace />} />
            <Route path="manual" element={<ManualPage />} />
            <Route path="manual/panel-board" element={<PanelBoardPage />} />
            <Route path="projects" element={<AuthGate><DashboardPage /></AuthGate>} />
            <Route path="projects/:id" element={<AuthGate><ProjectPage /></AuthGate>} />
            <Route path="designs/:id" element={<AuthGate><DesignPage /></AuthGate>} />
            <Route path="designs/:id/panel-board" element={<AuthGate><PanelBoardPage /></AuthGate>} />
            <Route path="*" element={<Navigate to="/manual" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
